import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrialBalanceService {
  private baseUrl = `${environment.baseUrl}fa/AccountingReport/TrialBalance`;

  constructor(private http: HttpClient) {}

  getTrialBalance(storeCode: string, fromDate: string, toDate: string, includeOpening: boolean = false): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.baseUrl}?storeCode=${storeCode}&fromDate=${fromDate}&toDate=${toDate}&includeOpening=${includeOpening}`
    );
  }

  getLedgerDetails(storeCode: string, fromDate: string, toDate: string, ledgerId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.baseUrl}fa/AccountingReport/Ledger?storeCode=${storeCode}&fromDate=${fromDate}&toDate=${toDate}&ledgerIds=${ledgerId}`
    );
  }
}
